import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";

const ConfirmationModal = ({
  isOpen,
  handleClose,
  onConfirm,
  isLoading,
  title,
  description,
  subtitle = '',
  confirmText = 'Confirm',
  loadingText = "Saving...",
}) => {
  const { t } = useTranslation();


  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="xs">
      <Box sx={{ padding: '16px' }}>
        <DialogTitle sx={{ position: 'relative', padding: '10px 16px 0', marginBottom: '20px' }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '18px', textAlign:'center' }}>
            {title}
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 0,
              top: 0,
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: '16px 16px 16px 16px' }}>
          {subtitle && <Typography sx={{ fontSize: '14px', fontWeight: 300, color: '#475467', marginBottom: '20px', textAlign:'center' }}>
            {subtitle}
          </Typography>}
          <Typography sx={{ fontSize: '14px', fontWeight: 300, color: '#475467', marginBottom: '10px', textAlign:'center' }}>
            {description}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", display: "flex", padding: "8px 16px", marginTop: '0' }}> {/* Smaller padding for buttons */}
          <Box sx={{ flex: 1, mr: 1 }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              fullWidth // Make Cancel button take full width
              sx={{
                height: "48px", // Ensure the height matches the Save button
                borderRadius: "8px",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "16px", marginRight: "5px" }}>
                {t("Cancel")}
              </Typography>
            </Button>
          </Box>
          <Box sx={{ flex: 1, ml: 1 }}>
            <Button
              onClick={onConfirm} // Call onSave function
              variant="contained"
              sx={{
                background: "#2F37B5",
                borderRadius: "8px",
                height: "48px", // Match height
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              disabled={isLoading} // Disable while loading
              fullWidth // Make Save button take full width
            >
              <Typography sx={{ color: "white", fontWeight: 600, fontSize: "16px", marginRight: "5px" }}>
                {isLoading ? <>
                <CircularProgress size={16} sx={{ color: "#000", marginRight: "5px" }} />
                 {loadingText}
                </>: t(confirmText)}
              </Typography>
            </Button>
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  selectedRow: PropTypes.object, // Add selectedRow prop type
};

export default ConfirmationModal;